export class NumberHelper {
    static Round(num: number, round = 2): number {
        let roundCoef: number = Math.pow(10, round);
        return Math.round((num + + 0.00001) * roundCoef) / roundCoef;
    }
} 